import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export function getKpisSteps(isDefault: boolean): DriveStep[] {
    return [
        {
            element: `#${ONBOARDING_IDS.KPIS_NAV}`,
            popover: {
                title: "KPI Methodology Tabs",
                description:
                    "Switch between two views: <b>Current</b> shows the active KPI configuration — the exact methodology being used right now to calculate all player scores. <b>Default</b> shows the app creators' recommended baseline configuration.",
            },
        },
        {
            element: `#${ONBOARDING_IDS.KPIS_CURRENT_INFO}`,
            popover: {
                title: isDefault ? "Default Configuration" : "Current Configuration",
                description: isDefault
                    ? "This banner confirms you're looking at the default setup — the baseline KPI configuration as proposed by the Jit Team."
                    : "This banner confirms you're looking at the live setup. If scores in the app don't match what's shown here, head to Settings to trigger a database recalculation.",
            },
        },
        {
            element: `#${ONBOARDING_IDS.KPIS_METHODOLOGY}`,
            popover: {
                title: "In-Depth Methodology",
                description:
                    "Everything below breaks down exactly how the scoring system works — from the big picture model overview down to individual stat categories, z-scores, and bonus rules. Each section can be expanded to dive deeper.",
            },
        },
    ];
}

export const kpisCurrentSteps: DriveStep[] = getKpisSteps(false);
